import Decimal from 'decimal.js'
import { YearString } from 'types'

// See here: https://day.js.org/docs/en/manipulate/add
export enum TimeUnit {
  DAY = 'day',
  DAYS = 'days',
  WEEK = 'week',
  WEEKS = 'weeks',
  MONTH = 'month',
  MONTHS = 'months',
  YEAR = 'year',
  YEARS = 'years',
  HOUR = 'hour',
  MINUTE = 'minute',
  SECOND = 'second',
  MILLISECOND = 'millisecond',
}

export interface TimeDuration {
  duration: number | null
  unit: TimeUnit
}

export type InspectionInterval = Record<string, TimeDuration>

export function convertDurationToYears(region?: TimeDuration): Decimal | null {
  if (!region?.duration || !region?.unit) {
    return null
  }

  const timeConversionFactors: { [key: string]: number } = {
    [TimeUnit.DAY]: 365,
    [TimeUnit.WEEK]: 52,
    [TimeUnit.MONTH]: 12,
    [TimeUnit.YEAR]: 1,
  }

  if (region.unit in timeConversionFactors) {
    return new Decimal(region.duration).div(timeConversionFactors[region.unit])
  }

  return null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isYearString(value: any): value is YearString {
  return typeof value === 'string' && /^\d{4}$/.test(value)
}

export function yearStringToNumber(year: YearString): number {
  return parseInt(year)
}

export function parseInspectionInterval(interval: unknown): InspectionInterval {
  if (!interval || typeof interval !== 'object') return {}

  const result: InspectionInterval = {}
  Object.entries(interval as Record<string, unknown>).forEach(
    ([key, value]) => {
      if (
        value &&
        typeof value === 'object' &&
        'duration' in value &&
        'unit' in value
      ) {
        result[key] = value as TimeDuration
      }
    }
  )
  return result
}

export interface TimePeriod {
  start: number
  end: number
  timeUnit: TimeUnit
}
